import React from 'react';

export default ({ className }) => (
  <svg className={className} viewBox='0 0 432 432' fill='none'>
    <g>
      <path
        fill='currentColor'
        d='M187.92,119.99v7.94h-19.12v-.65c0-7.56-.81-13.01-2.43-16.36-1.62-3.35-4.64-5.02-9.07-5.02-3.02,0-5.26,1.11-6.72,3.32-1.46,2.21-2.19,5.21-2.19,8.99v61.07c0,7.88,3.13,11.83,9.4,11.83,4.1,0,6.97-1.27,8.59-3.81,1.62-2.54,2.43-6.45,2.43-11.75v-11.99h-12.8v-15.88h32.89v59.29h-9.72l-3.73-8.75c-3.35,4-6.48,6.72-9.4,8.18s-6.48,2.19-10.69,2.19c-8.42,0-15.04-2.75-19.85-8.26-4.81-5.51-7.21-12.53-7.21-21.06v-61.4c0-8.53,2.59-15.58,7.78-21.14,5.18-5.56,12.42-8.34,21.71-8.34,6.26,0,11.69,1.38,16.28,4.13,4.59,2.75,8.04,6.54,10.37,11.34,2.32,4.81,3.48,10.18,3.48,16.12Z'
      />
      <path
        fill='currentColor'
        d='M258.18,149.8v17.01h-38.23v13.28c0,9.07,3.35,13.61,10.04,13.61,3.02,0,5.45-1,7.29-3,1.83-2,2.75-5.86,2.75-11.58v-1.62h18.14c-.22,10.59-2.7,18.41-7.45,23.49-4.75,5.08-11.66,7.61-20.74,7.61s-16.44-2.73-21.14-8.18c-4.7-5.45-7.05-13.31-7.05-23.57v-25.92c0-21.81,9.4-32.72,28.19-32.72,9.4,0,16.44,2.73,21.14,8.18,4.7,5.46,7.05,13.26,7.05,23.41ZM229.99,133.11c-3.24,0-5.73,1.13-7.45,3.4-1.73,2.27-2.59,5.67-2.59,10.21v5.18h20.09v-3.73c0-5.61-.87-9.53-2.59-11.74-1.73-2.21-4.21-3.32-7.45-3.32Z'
      />
      <path
        fill='currentColor'
        d='M305.64,119.83v14.9h-12.15v50.54c0,4.54,2.11,6.8,6.32,6.8h5.83v15.55c-2.59.65-5.56.97-8.91.97-7.13,0-12.47-1.67-16.04-5.02-3.56-3.35-5.35-8.1-5.35-14.26v-54.59h-10.04v-14.9h10.04v-23.49h18.14v23.49h12.15Z'
      />
      <path
        fill='currentColor'
        d='M115.08,341.98v-116.96h20.09v116.96h-20.09Z'
      />
      <path
        fill='currentColor'
        d='M204.59,271.19v70.79h-18.14v-67.88c0-1.83-.57-3.29-1.7-4.37-1.13-1.08-2.73-1.62-4.78-1.62-1.73,0-3.46.46-5.18,1.38-1.73.92-3.89,2.3-6.48,4.13v68.36h-18.14v-87.16h17.17v8.75c4.75-4.32,8.59-7.13,11.5-8.42s6.37-1.94,10.37-1.94c4.86,0,8.64,1.65,11.34,4.94,2.7,3.3,4.05,7.64,4.05,13.04Z'
      />
      <path
        fill='currentColor'
        d='M241.88,243.81v11.02h10.37v14.9h-10.37v72.25h-18.14v-72.25h-10.69v-14.9h10.69v-11.18c0-6.59,1.73-11.61,5.18-15.07s8.48-5.18,15.07-5.18h9.07v14.9h-5.02c-2.27,0-3.86.46-4.78,1.38-.92.92-1.38,2.3-1.38,4.13Z'
      />
      <path
        fill='currentColor'
        d='M316.92,284.96v26.08c0,21.71-9.4,32.56-28.19,32.56-9.4,0-16.44-2.73-21.14-8.18-4.7-5.45-7.05-13.31-7.05-23.57v-25.92c0-21.81,9.4-32.72,28.19-32.72,9.5,0,16.58,2.73,21.22,8.18,4.64,5.45,6.97,13.31,6.97,23.57ZM288.73,328.7c3.35,0,5.86-1.19,7.53-3.56,1.67-2.38,2.51-5.72,2.51-10.04v-33.37c0-9.07-3.35-13.61-10.04-13.61s-10.04,4.54-10.04,13.61v33.37c0,9.07,3.35,13.61,10.04,13.61Z'
      />
    </g>
  </svg>
);
